import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../components/Modal/Modal';
import CarSelector from './CarSelector';
import SelectedCarList from '../../../components/SelectedCarList/SelectedCarList';

const modalBodyClassName = 'w-[500px]';

const AddCarsModal = ({
  visible, toggleVisible, onSelect, preselect
}) => {
  const onCarSelect = (data) => {
    onSelect('articleCars', [...preselect, data]);
  };

  const onDelete = (index) => {
    onSelect('articleCars', [...preselect.filter((_, currentIndex) => index !== currentIndex)]);
  };

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Add cars"
      saveText="Select"
      hideSaveBtn
    >
      <div className={modalBodyClassName}>
        <SelectedCarList cars={preselect} onDelete={onDelete} />
        <br />
        <CarSelector onSelect={onCarSelect} />
      </div>
    </Modal>
  );
};

AddCarsModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  onSelect: PropTypes.func,
  preselect: PropTypes.arrayOf(PropTypes.shape({})),
};

AddCarsModal.defaultProps = {
  visible: false,
  toggleVisible: () => {},
  onSelect: () => {},
  preselect: [],
};

export default AddCarsModal;
